<template>
  <div :class="$attrs.class">
    <label :for="id" class="form-label">{{ label }} <span v-if="required">*</span> :</label>
    <div class="relative">
      <div class="absolute right-2 top-2 flex items-center">
        <input class="hidden js-password-toggle" type="checkbox" />

        <label v-if="type === 'password'" @click="show" class="px-2 py-1  cursor-pointer" for="toggle"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
        </svg></label>
        <label v-else @click="show" class="px-2 py-1  cursor-pointer" for="toggle"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
          <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
          <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
        </svg></label>
      </div>
      <input :id="id" class="static form-input" :type="type" autocomplete="off" v-bind="{ ...$attrs, class: null }" :class="{ error: error }" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
    </div>
    <hint :hint="hint" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Hint from '@/Shared/Hint'

export default {
  components: {Hint},
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: String,
    hint: String,
    required: Boolean,
    dateNotInFuture: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data(){
    return {
      type: 'password',
    }
  },
  methods: {
    show() {
      if(this.type === 'password'){
        this.type = 'text'
      } else {
        this.type = 'password'
      }
    },
  },
}
</script>
<style scoped>
input::placeholder{
  color:#adadad;
  font-size: 14px;
}
</style>
